import { render, staticRenderFns } from "./Outbox.vue?vue&type=template&id=41816413&scoped=true&"
import script from "./Outbox.vue?vue&type=script&lang=js&"
export * from "./Outbox.vue?vue&type=script&lang=js&"
import style0 from "./Outbox.vue?vue&type=style&index=0&id=41816413&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41816413",
  null
  
)

export default component.exports